<template>
  <v-container>
    <ExchangeRate></ExchangeRate>
    <v-data-table
      :headers="headers"
      :items="getProducts"
      sort-by="name"
      :search="search"
      :loading="loading"
      class="elevation-1"
      dense
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Productos formulas de producción</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-text-field
            v-model="search"
            label="Buscar"
            append-icon="mdi-magnify"
            class="mt-3 py-2 mr-2"
          ></v-text-field>
          <PFNewDialog :products="products"></PFNewDialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="d-flex flex-row align-center justify-center">
          <PFNewDialog v-if="item && item.uid" :icon="'edit'" :item="item" :products="products"></PFNewDialog>
          <reda-icon
            iconName="delete"
            @click="deleteItem(item)"
            :button="true"
          ></reda-icon>
        </div>
      </template>
      <template v-slot:item.cost="{ item }">
        <div class="d-flex align-center justify-end"><div>{{ getCostString(item) }}</div>
        <MaterialsDialog class="mx-2" :product="item" :products="products"></MaterialsDialog></div>
      </template>
      <template v-slot:item.taxes="{ item }">
        {{item.taxes && item.taxes.length ? Number(item.taxes[0].rate) : 0}}
      </template>
      <template v-slot:item.price="{ item }">
        {{ getPrice(item) }}
      </template>
      <template v-slot:item.currency="{ item }">
        {{(item.prices.findIndex( element => {return element.priceList == priceList}) > -1) ? item.prices[item.prices.findIndex( element => {return element.priceList == priceList})].currency : "No definida"}}
      </template>
    </v-data-table>
    <div class="ma-0 body-2">* El costo fijo se asigna al crear o actualizar un producto. Si el producto no tiene el valor definido se calcula en base a los materiales requeridos y si no cuenta con materiales se utiliza el precio de venta sin impuestos correspondiente</div>
  </v-container>
  </template>
<script>
import PFNewDialog from '@/components/PFNewDialog.vue'
import { mapGetters, mapActions } from 'vuex'
import tools from '@/api/tools.js'
import firebaseApi from '../api/firebaseApi'
import RedaIcon from '../components/RedaIcon.vue'
import MaterialsDialog from '../components/MaterialsDialog.vue'
import ExchangeRate from '../components/ExchangeRate.vue'
export default {
  name: 'OrviProducts',
  components: { PFNewDialog, RedaIcon, MaterialsDialog, ExchangeRate },
  data: () => ({
    listenerProducts: null,
    products: [],
    materials: [],
    search: '',
    loading: true,
    priceList: 'general',
    headers: [
      { text: 'Código', value: 'commercialCode' },
      { text: 'Descripción', value: 'description' },
      { text: 'Unidad', value: 'unit' },
      { text: 'Costo Fijo*', value: 'cost', align: 'end' },
      { text: 'Precio', value: 'price', align: 'end' },
      { text: 'IVA %', value: 'taxes', align: 'end' },
      { text: 'Acciones', value: 'action', sortable: false, align: 'center' }
    ],
    items: [],
    editedIndex: -1
  }),
  mounted: function () {
    this.reset()
  },
  beforeDestroy: function () {
    this.listenerProducts()
  },
  computed: {
    getProducts () {
      return this.products.filter(({ isMaterial, prices }) => (!isMaterial || prices?.length > 0))
    },
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Producto' : 'Editar Producto'
    },
    ...mapGetters('priceList', [
      'getPrices'
    ]),
    ...mapGetters('company', [
      'getCompany'
    ]),
    ...mapGetters([
      'getExchangeRateUSD',
      'getCurrency'
    ])
  },
  filters: {
    round10 (value) {
      if (!value) return 0
      tools.round10(value, -5)
    }
  },
  methods: {
    currencyFormat (value, currency, por = false, decimals = 2) {
      if (por) {
        if (!value && value !== 0) return 'No data'
        return (value * 100).toFixed(decimals) + '%'
      }
      const formatNumber = currency === 'CRC' ? 'es-CR' : 'es-US'
      if (isNaN(Number(value))) return value
      const numberFormat = new Intl.NumberFormat(formatNumber, { style: 'currency', currency })
      if (!value) return numberFormat.format(0)
      return numberFormat.format(value)
    },
    getMaterialCost (code, currency) {
      const product = this.products.find(({ commercialCode }) => commercialCode === code)
      // if (!product) console.log(code, [...this.products])
      let value = 0
      const price = product.prices?.length
        ? (product.prices.find(({ priceList }) => priceList === 'general') || product.prices[0])
        : null
      const projectedCostCurrency = product.projectedCostCurrency || 'CRC'
      const exchangeRate = projectedCostCurrency === currency ? 1
        : projectedCostCurrency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
      if (product?.projectedCost) return Number(product.projectedCost * exchangeRate)
      const steps = product?.steps || []
      steps.forEach(step => {
        value += (step.drm?.reduce((acc, { material, quantity }) => {
          const materialCost = this.getMaterialCost(material, currency)
          acc += (materialCost * quantity)
          return acc
        }, 0) || 0)
      })
      if (product?.isMaterial && price && !value) {
        const exchangeRate = price.currency === currency ? 1
          : price.currency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
        return Number(price.price * exchangeRate)
      }
      return value
    },
    getCostString (item) {
      // const price = item.prices.find((price) => price.priceList === this.priceList) ||
      //   item.prices.find((price) => price.priceList === 'general')
      const value = this.getMaterialCost(item.commercialCode, this.getCurrency)
      const stringValue = this.currencyFormat(
        value,
        this.getCurrency
      )
      return `${stringValue}`
    },
    getPrice (item) {
      const price = item.prices.find((price) => price.priceList === this.priceList) ||
        item.prices.find((price) => price.priceList === 'general')
      if (!price) return 'No definido'
      const priceValue = Number(price.price || 0)
      let value = 0
      let margin = ''
      if (price.margin) {
        margin += `(${priceValue * 100}%)`
        const unitPrice = (this.getMaterialCost(item.commercialCode, this.getCurrency) * (priceValue + 1))
        value = price?.round ? Math.ceil(unitPrice) : Number(unitPrice.toFixed(2))
      } else {
        const exchangeRate = price.currency === this.getCurrency ? 1
          : price.currency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
        value = Number(price.price) * exchangeRate
      }
      value *= (item.taxes && item.taxes.length > 0 ? 1 + (item.taxes[0].rate / 100) : 1)
      const stringValue = this.currencyFormat(
        value,
        this.getCurrency
      )
      return `${stringValue}${margin} IVAI`
    },
    customFilter (item, queryText, itemTitle) {
      try {
        const textOne = item.description.toLowerCase()
        const textTwo = item.code.toString()
        const searchText = queryText.toString().toLowerCase()

        return textOne.indexOf(searchText) > -1 ||
            textTwo.indexOf(searchText) > -1
      } catch (error) {
        console.error(error)
        console.log({ ...item })
      }
    },
    reset () {
      if (this.listenerProducts) this.listenerProducts()
      // redaApp.importAttachmentsVouchers().then(() => console.log('Importing from email')).catch((e) => console.error(e))
      this.listenerProducts = firebaseApi.db.collection('products')
        .where('company', '==', this.getCompany.identification)
        .onSnapshot(({ docs }) => {
          this.loading = true
          this.products = []
          for (let i = 0; i < docs.length; i++) {
            const doc = docs[i]
            const data = doc.data()
            // if (data.inventoryable) this.products.push({ ...data, uid: doc.id })
            this.products.push({ ...data, uid: doc.id })
          }
          this.loading = false
        })
    },

    deleteItem (item) {
      this.deleteProduct(item)
        .then((msj) => {
          console.log(msj)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    ...mapActions('priceList', ['cleanPrices', 'setPrices']),
    ...mapActions('message', ['showError']),
    ...mapActions('products', ['deleteProduct'])
  }
}
</script>
  <style type="text/css">

  </style>
